import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
    selector: 'notification-details',
    templateUrl: './notification-details.component.html',
    styleUrls: ['./notification-details.component.css']
})
export class NotificationDetailsComponent implements OnInit {
    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig
    ) {}

    ngOnInit(): void {}
}
